import { Smiley } from '@phosphor-icons/react';
import styles from './HelpUsImproveEditor.module.scss';
import { COMMON_ERROR_TEXT, SVG_SIZE_M } from 'src/constants';
import {
  FeedbackModal,
  FeedbackSubmitParams,
} from 'src/v2/commonComponents/FeedbackModal';
import { Button } from 'src/v2/commonComponents/Button';
import {
  useCurrentThreadId,
  useGetEditorThread,
  useGetUser,
  useToast,
  useVisible,
} from 'src/hooks';
import { useCreateEditorFeedbackMutation } from 'src/store/services';
import { getErrorStatus } from 'src/utils';
import { EditorFeedback } from 'src/types/feedback/models/EditorFeedback';
import { FeedbackV2Type } from 'src/types/feedback/models/FeedbackV2Type';

export const HelpUsImproveEditor = () => {
  const { user_id, isFreeTier, isOpenTier } = useGetUser();
  const { onShowToast } = useToast();
  const { currentThreadId } = useCurrentThreadId();
  const { artifactOutput } = useGetEditorThread();
  const {
    isVisible: isFeedbackModalVisible,
    onVisibilitySet: onFeedbackModalVisibilitySet,
    onVisibilityRemove: onFeedbackModalVisibilityRemove,
  } = useVisible();

  const [createEditorFeedback, { isLoading: isCreateLoading }] =
    useCreateEditorFeedbackMutation();

  const handleSubmit = async ({ rating, feedback }: FeedbackSubmitParams) => {
    if (!currentThreadId) {
      onShowToast(COMMON_ERROR_TEXT, 'error');
      return;
    }

    try {
      const data: EditorFeedback = {
        feedback_type: FeedbackV2Type.EDITOR,
        editor_id: currentThreadId,
        artifacts_index: artifactOutput?.currentIndex || 1,
        rating: {
          rating,
          reason: feedback,
        },
      };

      await createEditorFeedback({ user_id, data }).unwrap();

      onShowToast('Thank you for your feedback!', 'success');
    } catch (error) {
      if (getErrorStatus(error) === 404) {
        onShowToast('Error saving feedback.', 'error');
      } else {
        onShowToast(COMMON_ERROR_TEXT, 'error');
      }
    }
  };

  return (
    <>
      <FeedbackModal
        isOpen={isFeedbackModalVisible}
        onClose={onFeedbackModalVisibilityRemove}
        onSubmit={handleSubmit}
        isLoading={isCreateLoading}
      />

      <div className={styles.root}>
        <Button
          className={styles.container}
          color="transparent"
          onClick={onFeedbackModalVisibilitySet}
          disabled={isFreeTier || isOpenTier}
        >
          <Smiley size={SVG_SIZE_M} />
          <span>Help us improve Ninja Editor</span>
        </Button>
      </div>
    </>
  );
};
